export const emptyToNull = (args: string): string | null => {
    return args.length > 0 ? args : null;
}
